function updateBaseWidth () {
  const width = window.innerWidth
  const baseWidth = width
  // 根据视口宽度动态设置基准宽度
  if (width <= 768) {
    document.documentElement.style.setProperty('--base-width', 375)
  } else if (width <= 1200) {
    document.documentElement.style.setProperty('--base-width', 1200)
  } else if (width <= 1500) {
    document.documentElement.style.setProperty('--base-width', 1440)
  } else if (width <= 1700) {
    document.documentElement.style.setProperty('--base-width', 1800)
  } else if (width <= 1920) {
    document.documentElement.style.setProperty('--base-width', 2000)
  } else {
    document.documentElement.style.setProperty('--base-width', 1920)
  }

  // 根据视口宽度动态设置基准宽度
  if (width <= 750) {
    document.documentElement.style.setProperty('--base-width2', 750)
  } 
   if (width > 750 && width <= 1024) {
    document.documentElement.style.setProperty('--base-width2', 1024)
  } 
   if (width > 1024) {
    document.documentElement.style.setProperty('--base-width2', 1440)
  }
  // 根据视口宽度动态设置基准宽度 第二种 
  if (width > 1700) {
    document.documentElement.style.setProperty('--base-size', 1920);
  } else if (width > 1500) {
    document.documentElement.style.setProperty('--base-size', 1700);
  } else if (width > 1400) {
    document.documentElement.style.setProperty('--base-size', 1440);
  } else if (width > 1200) {
    document.documentElement.style.setProperty('--base-size', 1350);
  }else if (width > 1024) {
    document.documentElement.style.setProperty('--base-size', 1250);
  } else if (width > 768) {
    document.documentElement.style.setProperty('--base-size', 1050);
  } else if (width > 680) {
    document.documentElement.style.setProperty('--base-size', 950);
  }
  else {
    document.documentElement.style.setProperty('--base-size', 750);
  }





  if(baseWidth > 1920){
    document.documentElement.style.setProperty('--base-font', settings.blokess_font_1920_size);
  }else if(baseWidth > 1820 && baseWidth <= 1920){
    document.documentElement.style.setProperty('--base-font', settings.blokess_font_1820_size);
  }else if(baseWidth > 1720 && baseWidth <= 1820){
    document.documentElement.style.setProperty('--base-font', settings.blokess_font_1720_size);
  }else if(baseWidth > 1620 && baseWidth <= 1720){
    document.documentElement.style.setProperty('--base-font', settings.blokess_font_1620_size);
  }else if(baseWidth > 1520 && baseWidth <= 1620){
    document.documentElement.style.setProperty('--base-font', settings.blokess_font_1520_size);
  }else if(baseWidth > 1420 && baseWidth <= 1520){
    document.documentElement.style.setProperty('--base-font', settings.blokess_font_1440_size);
  }else if(baseWidth > 1320 && baseWidth <= 1420){
    document.documentElement.style.setProperty('--base-font', settings.blokess_font_1320_size);
  }else if(baseWidth > 1220 && baseWidth <= 1320){
    document.documentElement.style.setProperty('--base-font', settings.blokess_font_1220_size);
  }else if(baseWidth > 1120 && baseWidth <= 1220){
    document.documentElement.style.setProperty('--base-font', settings.blokess_font_1120_size);
  }else if(baseWidth > 1025 && baseWidth <= 1120){
    document.documentElement.style.setProperty('--base-font', settings.blokess_font_1024_size);
  }else if(baseWidth > 900 && baseWidth <= 1025){
    document.documentElement.style.setProperty('--base-font', settings.blokess_font_900_size);
  }else if(baseWidth > 800 && baseWidth <= 900){
    document.documentElement.style.setProperty('--base-font', settings.blokess_font_800_size);
  }else if(baseWidth > 700 && baseWidth <= 800){
    document.documentElement.style.setProperty('--base-font', settings.blokess_font_768_size);
  }else if(baseWidth > 600 && baseWidth <= 700){
    document.documentElement.style.setProperty('--base-font', settings.blokess_font_668_size);
  }else if(baseWidth > 500 && baseWidth <= 600){
    document.documentElement.style.setProperty('--base-font', settings.blokess_font_568_size);
  }else if(baseWidth > 400 && baseWidth <= 500){
    document.documentElement.style.setProperty('--base-font', settings.blokess_font_468_size);
  }else if(baseWidth > 300 && baseWidth <= 400){
    document.documentElement.style.setProperty('--base-font', settings.blokess_font_375_size);
  }else{
    document.documentElement.style.setProperty('--base-font', settings.blokess_font_375_size);
  }




  // if (width > 1700) {
  //   baseWidth = 1700
  //   document.documentElement.style.setProperty('--base-width', 1700)
  // } else if (width > 1500) {
  //   baseWidth = 1600
  //   document.documentElement.style.setProperty('--base-width', 1600)
  // } else if (width > 1400) {
  //   baseWidth = 1440
  //   document.documentElement.style.setProperty('--base-width', 1440)
  // } else if (width > 1200) {
  //   baseWidth = 1300
  //   document.documentElement.style.setProperty('--base-width', 1350)
  // } else if (width > 1024) {
  //   baseWidth = 1250
  //   document.documentElement.style.setProperty('--base-width', 1250)
  // } else if (width > 768) {
  //   baseWidth = 1000
  //   document.documentElement.style.setProperty('--base-width', 1050)
  // } else if (width > 680) {
  //   baseWidth = 1000
  //   document.documentElement.style.setProperty('--base-width', 950)
  // } else {
  //   baseWidth = 750
  //   document.documentElement.style.setProperty('--base-width', 750)
  // }

}
updateBaseWidth()
window.addEventListener('resize', updateBaseWidth)
